export const activities = {
  title: "Actividades diarias",
  subtitle: "Un día en Gándara",
  items: {
    personal: {
      title: "Trabajo personal",
      description: "Tiempo dedicado al desarrollo individual con materiales Montessori, permitiendo a cada niño/a avanzar a su propio ritmo"
    },
    workshops: {
      title: "Talleres y proyectos",
      description: "Actividades dirigidas que fomentan la creatividad, el trabajo en equipo y el aprendizaje práctico"
    },
    tutoring: {
      title: "Tutorías",
      description: "Momentos para el seguimiento personalizado del progreso académico y emocional"
    },
    assembly: {
      title: "Asamblea",
      description: "Espacio diario de conversación donde compartimos, reflexionamos y resolvemos conflictos en comunidad"
    },
    rest: {
      title: "Descanso y alimentación",
      description: "Pausas estructuradas para fomentar hábitos saludables y recargar energías"
    },
    play: {
      title: "Juego libre",
      description: "Tiempo esencial para la socialización, creatividad y desarrollo físico en entornos naturales"
    }
  }
};
